module.exports = __webpack_public_path__ + "img/wellken.fc0a0701.png";